import * as React from "react";

import * as userActions from "../../actions/user-actions";
import { connect } from "react-redux";
import { getBuilderTheme } from "sharedUI/styles";
import { RootState } from "../../store/types";
import { getUserFlags } from "common/Database";
import { useOSThemeDark } from "../../sharedUI/lib/color-theme-utils";
import { TailwindThemeProvider } from "sharedUI/lib/tailwind-theme-provider";

interface Props {
    builderTheme: "light" | "dark";
    useSystemTheme: boolean;
}

const ThemedEnvironment: React.FunctionComponent<Props> = p => {
    const { builderTheme, useSystemTheme, children } = p;

    const isOSDarkTheme = useOSThemeDark();

    const t = React.useMemo(() => {
        let theme = builderTheme;
        if (useSystemTheme) {
            theme = isOSDarkTheme ? "dark" : "light";
        }

        return getBuilderTheme(theme === "dark" ? true : false);
    }, [builderTheme, isOSDarkTheme, useSystemTheme]);

    return (
        <TailwindThemeProvider theme={t}>
            <>{children}</>
        </TailwindThemeProvider>
    );
};

const mapState = (state: RootState) => ({
    builderTheme: getUserFlags(state.userData).builderTheme,
    useSystemTheme: getUserFlags(state.userData).useSystemTheme,
});

const mapDispatch = {
    setBuilderTheme: userActions.setBuilderTheme,
};

export default connect(mapState, mapDispatch)(ThemedEnvironment);
